import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../../component/shared/footer";
// import NavBar from "../../component/shared/navBar/test/Navbar";
import NavBar from "../../component/shared/navBar";

const Main = () => {
  return (
    <div>
      {/* <NavBar /> */}
      <NavBar />
      <Outlet />
      <Footer />
    </div>
  );
};

export default Main;
